import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

export const getDetailCompanyLegality = createAsyncThunk('/dashboard_detail_company_legality/content', async (id) => {
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/dashDetailCompanyLegality/${id}`, {})
    return response.data;
})


export const dashboardDetailCompanyLegalitySlice = createSlice({
    name: 'dashboard_detail_company_legality',
    initialState: {
        isLoading: false,
        dashboard_detail_company_legality: []
    },

    /*extraReducers: {
        [getDetailCompanyLegality.pending]: state => {
            state.isLoading = true
        },
        [getDetailCompanyLegality.fulfilled]: (state, action) => {
            state.dashboard_detail_company_legality = action.payload.data
            state.isLoading = false
        },
        [getDetailCompanyLegality.rejected]: state => {
            state.isLoading = false
        },
    }*/
    extraReducers: (builder) => {
        builder
            .addCase(getDetailCompanyLegality.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getDetailCompanyLegality.fulfilled, (state, action) => {
                state.dashboard_detail_company_legality = action.payload.data;                  
                state.isLoading = false;
            })
            .addCase(getDetailCompanyLegality.rejected, (state) => {
                state.isLoading = false;
            });
    }   
})

export default dashboardDetailCompanyLegalitySlice.reducer